define(["require", "exports", "tslib", "mobx-react", "react", "./index"], function (require, exports, tslib_1, mobx_react_1, React, index_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FormItem = void 0;
    React = tslib_1.__importStar(React);
    exports.FormItem = (0, mobx_react_1.observer)((props) => {
        return React.createElement(index_1.HGroup, { className: "form-field" },
            React.createElement("span", { className: "label" }, props.id),
            props.children);
    });
});
